import { type StateCreator } from 'zustand';

export enum Theme {
  Light = 'light',
  Dark = 'dark',
  /** @public — theme value supported by the slice; the switcher UI doesn't expose it yet */
  System = 'system',
}

export type ThemeSlice = {
  theme?: Theme;
  clearTheme: () => void;
  setTheme: (theme?: Theme) => void;
};

export type CreateThemeSlice = (
  initialState: Pick<Partial<ThemeSlice>, 'theme'>,
) => StateCreator<ThemeSlice, [], [], ThemeSlice>;

export const createThemeSlice: CreateThemeSlice = (initialState) => (set) => ({
  theme: initialState.theme,
  clearTheme: () => set({ theme: undefined }),
  setTheme: (theme) => set({ theme }),
});
